import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CHUNK_LOAD_ERROR_EVENT } from '@/hooks/useVersionCheck';

// When a lazy-loaded chunk fails (e.g. 404 after a new deploy), show "new version available" so user can refresh
function isChunkLoadError(event: ErrorEvent): boolean {
  const msg = event.message?.toLowerCase() ?? '';
  return (
    msg.includes('loading chunk') ||
    msg.includes('dynamically imported module') ||
    msg.includes('failed to fetch dynamically imported module') ||
    (event.filename !== undefined && event.filename !== '' && msg.includes('import'))
  );
}
window.addEventListener('error', (event: ErrorEvent) => {
  if (isChunkLoadError(event)) {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent(CHUNK_LOAD_ERROR_EVENT));
    return true;
  }
  return false;
});

// Unhandled promise rejections from failed dynamic imports (e.g. import() failed)
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message ?? event.reason ?? '').toLowerCase();
  if (
    msg.includes('loading chunk') ||
    msg.includes('dynamically imported module') ||
    msg.includes('failed to fetch dynamically imported module')
  ) {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent(CHUNK_LOAD_ERROR_EVENT));
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

